import React from "react";
import { FormattedMessage } from "react-intl";
export default function getMaxLengthError(value, maxLength) {
    return value != null && value.length > maxLength ? (<FormattedMessage id="errors.maxLength" defaultMessage={`Cannot be more than {maxLength, number} {maxLength, plural, one {character} other {characters}}`} values={{ maxLength }}/>) : null;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/getMaxLengthError.tsx